module.exports = __webpack_public_path__ + "img/head-banner.21add2c5.jpeg";